import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';
import axios from 'axios';

import { apartmentModelGet, } from '../../models/apartments/apartment';
import {
    globalSettings, styles, validatePhoneNumber, sendMessageCloseCurrentWindowAsync, buttonProcessGet, validateDecimals, numberSet, languageObjGet,
    isUndNullEmp, awaitDelay, isUndNull, responseGet,
} from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'AparmentAdd';

//const { app, collections: dbColle, icons, labels, messages, react, } = globalSettings;
const { app, icons, labels, messages } = globalSettings;
//const { properties: dbProps, } = dbColle;
//const { operators: dbOpera, } = react?.firebase;
const { backend, } = app;

export default function AparmentAdd({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    userRole = '',
    building = buildingModelGet({}),
    buildingFloors = [],
    apartment = apartmentModelGet({}),
    setApartment = () => { },
    dtApartmentsId = {
        assignedAliquot: 0.00,
        setAssignedAliquot: () => { },
        remainingAliquot: 0.00,
        setRemainingAliquot: () => { },
    },
    aliquotPercentage = {
        assignedAliquot: 0.00,
        setAssignedAliquot: () => { },
        remainingAliquot: 0.00,
        setRemainingAliquot: () => { },
    },
    processType = 0,
    percentageValues = {
        empty: 0.00,
        full: 0.00,
    },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [floorError, setFloorError] = useState('');
    const [identifierError, setIdentifierError] = useState('');
    const [parkingPlaceError, setParkingPlaceError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');
    const [aliquotPercentageError, setAliquotPercentageError] = useState('');
    const buildingAliquotPercentage = building?.settings?.accountsReceivable?.aliquotPercentage || false;
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning mx-1',
                id: 'btnModalApartmentSave',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnModalApartmentBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalApartmentClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            // buildings: {
            //     inputs: {
            //         search: {
            //             id: `${dtBuildingsId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtBuildingsId}_length select`,
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'iconModalApartmentSave',
                className: icons?.save,
            },
            back: {
                id: 'iconModalApartmentBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'iconModalApartmentClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            description: {
                id: 'inputModalApartmentDescription',
                className: 'form-control bg-transparent text-black',
            },
            identificator: {
                id: 'inputModalApartmentIdentificator',
                className: 'form-control',
            },
            parkingsStall: {
                id: 'inputModalApartmentParkingsStall',
                className: 'form-control',
            },
            phoneNumber: {
                id: 'inputModalApartmentPhoneNumber',
                className: 'form-control',
            },
            aliquotPercentage: {
                id: 'inputModalApartmentAliquotPercentage',
                className: 'form-control text-right',
            },
        },
        selects: {
            floors: {
                id: 'selModalApartmentFloors',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spModalApartmentSave',
                className: '',
            },
            back: {
                id: 'spModalApartmentBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }

            setApartment(apartmentModelGet({
                buildingId: building.id,
                floor: 0,
                userId: '',
            }));

            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
            setShowModal(!isModalClose);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setApartment({ ...apartment, [property]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const apartmentDataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'apartmentDataSetAsync';
        let response = responseGet();
        try {
            apartment.aliquotPercentage = !isUndNullEmp({ data: apartment?.aliquotPercentage, subMethod: currentMethod, })?.result ?
                parseFloat(apartment?.aliquotPercentage) : percentageValues?.empty;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (apartment?.floor < 0) {
                setFloorError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: apartment?.identifier, subMethod: currentMethod, })?.result) {
                setIdentifierError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: apartment?.phoneNumber, subMethod: currentMethod, })?.result && !validatePhoneNumber({ phoneNumber: apartment.phoneNumber, })) {
                setPhoneNumberError(messages?.youMustEnterValidPhoneNumber?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (buildingAliquotPercentage) {
                if (isUndNull({ data: apartment?.aliquotPercentage, subMethod: currentMethod, })?.result) {
                    setAliquotPercentageError(messages?.theValueMustBeGreaterThanOrEqualToZeroAndLessThanOneHundred?.[languageObj?.id]);
                    response.isWarning = true;
                } else if (apartment?.aliquotPercentage < percentageValues?.empty || apartment?.aliquotPercentage > percentageValues?.full) {
                    setAliquotPercentageError(messages?.theValueMustBeGreaterThanOrEqualToZeroAndLessThanOneHundred?.[languageObj?.id]);
                    response.isWarning = true;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setFloorError('');
            setIdentifierError('');
            setPhoneNumberError('');
            setParkingPlaceError('');
            setAliquotPercentageError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentAddPostAsync';
        let response = responseGet();
        try {
            //#region variables
            let assignedAliquotLocal = percentageValues?.empty;
            let remainingAliquotLocal = percentageValues?.empty;
            //#endregion variables

            //#region initialize
            e?.preventDefault();

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await apartmentDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data save
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                apartment: apartment,
                languageId: languageObj?.id,
                languageCode: languageObj?.code,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartments}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartment = response?.result;
            //#endregion data save

            //#region dataTable set
            $(`#${dtApartmentsId}`)?.DataTable()?.row?.add([
                apartment?.identifier,
                apartment?.floor,
                apartment?.phoneNumber,
                buttonProcessGet({
                    id: apartment?.id,
                    description: apartment?.identifier,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result
            ])?.draw(true);
            //#endregion dataTable set

            //#region calculate aliquot percentage
            assignedAliquotLocal = numberSet({
                number: (aliquotPercentage.assignedAliquot + apartment?.aliquotPercentage),
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            aliquotPercentage.setAssignedAliquot(assignedAliquotLocal);
            remainingAliquotLocal = numberSet({
                number: (percentageValues?.full - assignedAliquotLocal),
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            aliquotPercentage.setRemainingAliquot(remainingAliquotLocal);
            //#endregion calculate aliquot percentage

            //#region Close modal
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //#endregion Close modal

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.icons?.close?.id}`)?.removeClass();

                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save?.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.icons?.close?.id}`)?.addClass(controls?.icons?.close?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            $(`#${controls?.inputs?.description?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.floors?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.identificator?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.parkingsStall?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.phoneNumber?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.aliquotPercentage?.id}`).attr('readOnly', (processType !== 0));

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region old code
            // $(`#${controls?.dataTables?.buildings?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.buildings?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion old code

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.apartment?.[languageObj?.id]} src={globalSettings?.images?.apartmentsLogo} style={styles?.cardHeaderLogo}></img> - {processType === 0 ? labels?.add?.[languageObj?.id] : labels?.edit?.[languageObj?.id]}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    //className='close btn-danger fas fa-window-close'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnHeader', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ? apartmentAddPostAsync({ e: e, subMethod: 'btn - save' }) : e?.preventDefault()}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processType === 0 ? apartmentAddPostAsync(e) : e?.preventDefault()}> */}

                    {/* Header */}
                    {/* <div className='card-header'>
                                <h6 className='card-title'>
                                    <img alt={labels?.apartment?.[languageObj?.id]} src={globalSettings?.images?.apartmentsLogo} style={styles?.cardHeaderLogo}></img> - {labels?.apartment?.[languageObj?.id]}
                                </h6>
                            </div> */}

                    {/* Body */}
                    {/* <div className='card-body'> */}
                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.description?.id}
                                className={controls?.inputs?.description?.className}
                                //autoFocus
                                placeholder={labels?.name?.[languageObj?.id]}
                                readOnly
                                value={building?.description || ''}
                                tooltip='tooltip'
                                title={labels?.name?.[languageObj?.id]} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={icons?.building} />
                                </div>
                            </div>
                        </div>
                        {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div> */}
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    {/* {!isUndNullEmp({ data: buildingFloors, subMethod: currentMethod, })?.result ? */}
                                    <select id={controls?.selects?.floors?.id}
                                        className={controls?.selects?.floors?.className}
                                        value={apartment?.floor || -1}
                                        onChange={(e) => formDataSetAsync({ property: 'floor', value: parseInt(e?.target?.value), subMethod: 'input - floor', })}
                                        onFocus={() => setFloorError('')}
                                        placeholder={labels?.floor?.[languageObj?.id]}
                                        tooltip='tooltip'
                                        title={labels?.floor?.[languageObj?.id]}>
                                        <option value={-1}>{messages?.selectFloor?.[languageObj?.id]}</option>
                                        {buildingFloors?.map((buildingFloor) => <option key={buildingFloor?.value} value={buildingFloor?.value}>{buildingFloor?.label}</option>)}
                                    </select>
                                    {/* : */}
                                    {/* <></> */}
                                    {/* } */}
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.layerGroup} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(floorError)}</div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.identificator?.id}
                                        className={controls?.inputs?.identificator?.className}
                                        placeholder={labels?.identifier?.[languageObj?.id]}
                                        onChange={(e) => formDataSetAsync({ property: 'identifier', value: e?.target?.value, subMethod: 'input - identifier', })}
                                        onFocus={() => setIdentifierError('')}
                                        value={apartment?.identifier || ''}
                                        tooltip='tooltip'
                                        title={labels?.identifier?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.sign} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(identifierError)}</div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.parkingsStall?.id}
                                        className={controls?.inputs?.parkingsStall?.className}
                                        onChange={(e) => formDataSetAsync({ property: 'parkingPlace', value: parseInt(e?.target?.value), subMethod: 'input - parkingsStall', })}
                                        onFocus={() => setParkingPlaceError('')}
                                        tooltip='tooltip'
                                        title={labels?.parkingStalls?.[languageObj?.id]}
                                        placeholder={labels?.parkingStalls?.[languageObj?.id]}
                                        type='number'
                                        value={apartment?.parkingPlace || ''} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.car} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(parkingPlaceError)}</div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.phoneNumber?.id}
                                        className={controls?.inputs?.phoneNumber?.className}
                                        //className='form-control'
                                        placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                        onChange={(e) => formDataSetAsync({ property: 'phoneNumber', value: e?.target?.value, subMethod: 'input - phoneNumber', })}
                                        onFocus={() => setPhoneNumberError('')}
                                        value={apartment?.phoneNumber || ''}
                                        tooltip='tooltip'
                                        title={labels?.phoneNumber?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.fax} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(phoneNumberError)}</div>
                            </div>
                        </div>
                    </div>

                    {buildingAliquotPercentage ?

                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input id={controls?.inputs?.aliquotPercentage?.id}
                                            className={controls?.inputs?.aliquotPercentage?.className}
                                            //className='form-control text-right'
                                            // onChange={(e) => formDataSetAsync({
                                            //     property: 'aliquotPercentage',
                                            //     value: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - aliquotPercentage', }),
                                            //     subMethod: 'input - aliquotPercentage',
                                            // })}

                                            onChange={(e) => formDataSetAsync({
                                                property: 'aliquotPercentage',
                                                value: isNaN(parseFloat(validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - aliquotPercentage', }))) ?
                                                    numberSet({ number: `${percentageValues?.empty}`, type: 'd', languageId: languageObj?.id, subMethod: 'input - aliquotPercentage', })?.result :
                                                    validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - aliquotPercentage', }),
                                            })}
                                            onFocus={() => setAliquotPercentageError('')}
                                            tooltip='tooltip'
                                            title={`% ${labels?.aliquot?.[languageObj?.id]}`}
                                            placeholder={`% ${labels?.aliquot?.[languageObj?.id]}`}
                                            // value={separatorsNumbersSet({
                                            //     number: apartment?.aliquotPercentage || percentageValues?.empty,
                                            //     withDecimals: true,
                                            //     consoleLogErrorShow: true,
                                            //     subMethod: 'input - aliquotPercentage',
                                            // })?.result} />
                                            //value={apartment?.aliquotPercentage || percentageValues?.empty} 
                                            value={apartment?.aliquotPercentage || `0.00`} />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={icons?.percentage} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(aliquotPercentageError)}</div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(phoneNumberError)}</div>
                                </div>
                            </div>
                        </div>
                        : <></>
                    }
                    {/* </div> */}

                    {/* Footer */}
                    {/* <div className='card-footer'>
                                <div className='form-group text-right'>
                                    <button className='btn btn-outline-warning mx-1'
                                        tooltip='tooltip'
                                        title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                        type='submit'>
                                        <i className={icons?.save}></i>
                                    </button>
                                    <button className='btn btn-outline-success'
                                        tooltip='tooltip'
                                        title={labels?.close?.[languageObj?.id]}
                                        type='reset'
                                        onClick={() => defaultValueSetAsync({isModalClose: true, subMethod: 'modal - btnFooter',})}>
                                        <i className={icons?.arrowCircleLeft}></i>
                                    </button>
                                </div>
                            </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>

                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            tooltip='tooltip'
                            title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnFooter', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}